import { formatDistance, format } from 'date-fns';
import moment from 'moment-timezone';
import { arSA, enUS } from 'date-fns/locale';
import { constants, getFromLocalStorage } from './localStorage';
import { _t } from 'app/utils/i18n';
const lang: 'en' | 'ar' = getFromLocalStorage(constants.language);

const langMap = {
  en: enUS,
  ar: arSA,
};
const getDateWithoutDay = (fullDate: string): string => {
  const dateWithoutDay = fullDate?.split('/').slice(1).join('/');
  return dateWithoutDay ? dateWithoutDay : fullDate;
};

export const SERVER_TIME_ZONE = 'Atlantic/Reykjavik';
export const DEFAULT_TIME_ZONE = 'Asia/Dubai';
export const DEFAULT_FORMAT = 'dd/mm/yyyy';

export const newFormater=( dateTime: string, dateFormat: string,)=>{
  return format(
    dateTime.replace('Z', ''),
    dateFormat,
    {
      locale: langMap[lang],
    }
  )
}

export const dateTimeFormatter = {
  date: (
    dateTime: string,
    dateFormat?: string,
    timeFormate?: boolean,
    excludeDay?: boolean
  ): string => {
    // Check if data is undefined or null
    if (!dateTime || !dateTime.length || dateTime.startsWith('000')) {
      return '-';
    }
    const Format: string =
      dateFormat ||
      getFromLocalStorage(constants.TIME_FORMAT) ||
      DEFAULT_FORMAT;
    const is24 = getFromLocalStorage(constants.TIME_24);
    const formatDate = Format?.replaceAll?.('m', 'M') || DEFAULT_FORMAT;
    const timeZoneDate = fromServerToLocalTimeZone(dateTime);
    const fullDate = format(
      timeZoneDate,
      timeFormate
        ? `${formatDate} , ${is24 ? 'HH:mm' : 'hh:mm a'}`
        : formatDate,
      {
        locale: langMap[lang],
      }
    );
    return dateTime
      ? excludeDay
        ? getDateWithoutDay(fullDate)
        : fullDate
      : '-';
  },
  distance: (date: any): string =>
    formatDistance(new Date(date || new Date()), new Date(), {
      locale: langMap[lang],
    }),
  time: (date: Date | string): string =>
    format(new Date(date), 'hh:mm a', { locale: langMap[lang] }),
};

export const fixed24HoursFormatter = (
  index: number,
  notCurrentDay?: boolean,
  filterType = 'DAY'
): any => {
  if (index === 0 && filterType === 'DAY')
    return _t(`basic:${notCurrentDay ? 'yesterday' : 'now'}`);

  if (index === 0 && filterType === 'WEEK' && !notCurrentDay)
    return _t('basic:today');

  if (index === 0 && filterType === 'MONTH' && !notCurrentDay)
    return _t('basic:thisWeek');

  if (index === 0 && filterType === 'YEAR' && !notCurrentDay)
    return _t('basic:thisMonth');

  if (filterType === 'DAY')
    return _t('basic:about_hours', {
      time: notCurrentDay ? index + 24 : index,
    } as any);

  if (filterType === 'WEEK')
    return _t('basic:dayAgo', {
      day: notCurrentDay ? index + 7 : index,
    } as any);

  if (filterType === 'MONTH')
    return _t('basic:weekAgo', {
      week: notCurrentDay ? index + 4 : index,
    } as any);
  if (filterType === 'YEAR')
    return _t('basic:monthAgo', {
      month: notCurrentDay ? index + 12 : index,
    } as any);
};

export const fromLocalToServerTimeZone = (date: string): string => {
  const timeZoneDate = moment.tz(
    date.replace('Z', ''),
    getFromLocalStorage(constants.TIME_ZONE) || DEFAULT_TIME_ZONE
  );
  const serverDate = timeZoneDate.clone().tz(SERVER_TIME_ZONE);
  return serverDate.toISOString();
};

export const fromServerToLocalTimeZone = (date: string): Date => {
  const serverDate = moment.tz(date?.replace('Z', ''), SERVER_TIME_ZONE);
  const localZoneDate = serverDate
    .clone()
    .tz(getFromLocalStorage(constants.TIME_ZONE) || DEFAULT_TIME_ZONE)
    .subtract(2, 'h');
  return localZoneDate.toDate();
};
